<template>
  <div class="body">
    <Header headerColor="white" />
    <div class="title-wrapper">
      <div class="title">Wecobi’s Environmental Impact</div>
    </div>
  </div>
</template>

<script>
import Header from "../SharedComponents/Header.vue";

export default {
  name: "HeroSection",
  components: {
    Header,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
  width: 100%;
  height: 404px;
  background-image: url("../../assets/sustainability/environment-backg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.title-wrapper {
  width: 100%;
  height: 308px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title {
  max-width: 568px;
  font-size: 50px;
  color: #ffffff;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 1280px) {
  .title {
    max-width: 455px;
    font-size: 40px;
  }
}
@media (max-width: 588px) {
  .title {
    max-width: 398px;
    font-size: 35px;
  }
}
@media (max-width: 588px) {
  .title {
    max-width: 370px;
    font-size: 30px;
  }
}
</style>
